import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class UploadDataService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  /**
   * Subir un archivo al servidor.
   * @param formData - FormData que contiene el archivo.
   * @param path - Ruta en el backend donde se subirá el archivo.
   * @returns Observable con la respuesta del servidor.
   */
  uploadFile(formData: FormData, path: string): Observable<any> {
    // Solo limpiar barras extras del path
    const cleanPath = path.replace(/^\/+|\/+$/g, '');
    
    // Construir la URL usando el endpoint de documentos para vehículos
    const url = `${this.apiUrl}/upload/${cleanPath}`;
    
    console.log('URL de carga servidor:', url); // Para debugging
    
    // Asegurarse de que el FormData tenga el archivo con el nombre 'file'
    const file = formData.get('file');
    if (!file) {
      console.warn('No se encontró el archivo en FormData');
      throw new Error('No se encontró el archivo');
    }

    // Realizar la petición POST
    return this.http.post(url, formData)
      .pipe(
        map((response: any) => {
          if (response && response.url) {
            // Limpiar la URL antes de devolverla
            response.url = response.url
              .replace(/([^:]\/)\/+/g, '$1')
              .replace(/localhost:3000/, environment.apiUrl);
          }
          return response;
        })
      );
  }

  /**
   * Subir un archivo a firebase storage.
   * @param formData - FormData que contiene el archivo.
   * @param path - Ruta en el backend donde se subirá el archivo.
   * @returns Observable con la respuesta del servidor.
   */
  uploadFileFirebase(formData: FormData, path: string): Observable<any> {    
    // Limpiar path de barras o interrogaciones accidentales al inicio
    const cleanPath = path.replace(/^\/+|\/+$/g, '').replace(/^\?path=/, '');

    // Construir URL usando encodeURIComponent para evitar problemas con espacios o caracteres especiales
    const url = `${this.apiUrl}/firebase/upload?path=${encodeURIComponent(cleanPath)}`;

    console.log('URL de carga firebase:', url); // Para debugging

    // Asegurarse de que el FormData tenga el archivo con el nombre 'file'
    const file = formData.get('file');
    if (!file) {
      console.warn('No se encontró el archivo en FormData');
      throw new Error('No se encontró el archivo');
    }

    // Realizar la petición POST
    return this.http.post(url, formData)
      .pipe(
        map((response: any) => {
          if (response && response.url) {
            // Limpiar la URL antes de devolverla
            response.url = response.url
              .replace(/([^:]\/)\/+/g, '$1')
              .replace(/localhost:3000/, environment.apiUrl);
          }
          return response;
        })
      );
  }

  /**
   * Descargar un archivo desde el servidor.
   * @param path - Ruta en el backend desde donde se descargará el archivo.
   * @returns Observable con el archivo como blob.
   */
  downloadFile(path: string): Observable<any> {
    console.log('Descargando archivo...');    
    const url = `${this.apiUrl}/upload/${path}`; // <--- ASEGÚRATE DE QUE HAYA UNA BARRA AQUÍ
    
    console.log('Ruta del servidor:', url);

    return this.http.get(url, {
      responseType: 'blob'
    });
  }

  /**
   * Eliminar un archivo del servidor.
   * @param path - Ruta en el backend del archivo a eliminar.
   * @returns Observable con la respuesta del servidor.
   */
  deleteFile(path: string): Observable<any> {
    console.log('Eliminando archivo...');
    console.log('Ruta del servidor:', `${this.apiUrl}/upload/${path}`);

    const url = `${this.apiUrl}/upload/${path}`;
    return this.http.delete(url);
  }

  /**
   * Subir un archivo específicamente para una solicitud.
   * @param formData - FormData que contiene el archivo.
   * @param solicitudId - ID de la solicitud
   * @param itemId - ID del item
   * @returns Observable con la respuesta del servidor.
   */
  uploadSolicitudFile(formData: FormData, solicitudId: number, itemId: number): Observable<any> {
    console.log('Subiendo archivo de solicitud...');
    
    const file = formData.get('file');
    if (!file) {
      console.warn('No se encontró el archivo en FormData');
      throw new Error('No se encontró el archivo');
    }

    const url = `${this.apiUrl}/upload/solicitudes/${solicitudId}/${itemId}`;
    return this.http.post(url, formData);
  }
}
